import React, { useEffect, useState } from 'react';
import logo from './images/coronary-flow-logo-light.png'
import Home from "./Pages/Home";
import Print from "./Pages/Print";
// import { clearFileStorage } from './helpers/utils';
import { reset, setOverlayStatus } from "./Components/Store/LoadReducer";
import { useDispatch, useSelector } from "react-redux";
import loader from './images/loader-animate.svg';
import { customAxios } from './helpers/utils';

function App() {
    const overlayStatus = useSelector(item => item.flowviewer.overlayStatus);
    const files = useSelector(item => item.flowviewer.files);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();

    async function complete() {
        customAxios().get("/study/complete")
            .then(() => {
                dispatch(setOverlayStatus("blocked"));
            })
            .catch((error) => {
                // TODO: Log error
            });
    }

    return (
        <div className="container-fluid p-0">
            <nav className="header">
                <div className="d-flex align-items-center">
                    <div className="wrap-left ps-2 d-flex align-items-center">
                        <img src={logo} alt="Biome science - CoronaryFlow" height="70" className="m-auto" />
                    </div>
                    <div className="d-flex flex-grow-1">
                        <div className="d-flex align-items-center justify-content-end" style={{width: '1601px', margin: '0 0.5rem'}}>
                            <button onClick={() => complete()} className="calc-btn m-0 ms-3">
                                Complete
                            </button>
                            {
                                page === 1 ?
                                    <button onClick={() => files["coloring"] ? setPage(2) : false}
                                        className={files["coloring"] ? "calc-btn m-0 ms-3" : "calc-btn m-0 ms-3 disabled"}>
                                        Print
                                    </button>
                                    :
                                    <button onClick={() => setPage(1)} className="calc-btn m-0 ms-3">
                                        Flow
                                    </button>
                            }
                        </div>
                    </div>
                </div>
            </nav>
            <div className="page-content">
                {
                    overlayStatus !== false ?
                        <div className={"page-content-overlay " + overlayStatus}>
                            <img className="spinner" src={loader} alt="Biome FlowViewer Loading" />
                        </div>
                        : ""
                }
                {
                    page === 1 && <Home />
                }
                {
                    page === 2 && <Print />
                }
            </div>
        </div>
    );
}

export default App;
